export enum SQL_PROVIDER {
  BigQuery = 'bigquery',
  DataBricks = 'databricks',
  Snowflake = 'snowflake',
  Trino = 'trino',
  Redshift = 'redshift'
}

export const sqlProviderLabels: { [key in SQL_PROVIDER]: string } = {
  [SQL_PROVIDER.BigQuery]: 'BigQuery',
  [SQL_PROVIDER.DataBricks]: 'Databricks (SQL)',
  [SQL_PROVIDER.Snowflake]: 'Snowflake',
  [SQL_PROVIDER.Trino]: 'Trino',
  [SQL_PROVIDER.Redshift]: 'Redshift'
};
